import { IconProps } from "./icon.type";

export function IcSidebarHomeActive({ ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43066 0.869502C8.94824 -0.287881 11.0518 -0.287881 12.5693 0.869502L18.332 5.26501C19.3829 6.06649 20 7.3125 20 8.63415V15.764C19.9999 18.1042 18.1028 20.0013 15.7627 20.0013H4.2373C1.89716 20.0013 0.000101529 18.1042 0 15.764V8.63415C0 7.3125 0.617079 6.06649 1.66797 5.26501L7.43066 0.869502ZM10 7.00134C8.34315 7.00134 7 8.34448 7 10.0013V13.0013C7.00012 14.6581 8.34322 16.0013 10 16.0013C11.6568 16.0013 12.9999 14.6581 13 13.0013V10.0013C13 8.34448 11.6569 7.00134 10 7.00134Z"
        fill="currentColor"
      />
    </svg>
  );
}
